import { IDataConnectionEditModel } from '~src/connectivity/components/EditConnection/EditConnectionDialog';
import { IDataConnectionInfoProperties } from '~src/datasource/dataConnection/models/IDataConnectionInfo';
import { IIdItemInfo } from '~src/spacesPlatform/models/resourceInfoParts';

export const SalesforceConnectionType = 'salesforce'; // Maybe move to ServerApi
export let PasswordUnchanged: string = null;
export type CredentialOption = 'none'|'oauth'|'password'|'mixed';

export interface IOAuthConnectionEditModel {
  credentialOption: CredentialOption;
  credentialId?: string;
  credentialNoValueOptionText?: string; // this will be set if there is an extra null credential option
  usingManagedKeychain?: boolean; // this will be set if the OAuth Connection is using managed keychain as embedded credential.
  usingRemoteQueryAgent?: boolean;
  usernamePassword?: IDataConnectionEditModel;  // For Salesforce
}

export interface ITestConnectionResult {
  isPending: boolean;
  succeeded?: boolean;
  messages?: string[];
}

export type EditableConnection = IDataConnectionInfoProperties&IIdItemInfo;